import { toast } from "react-toastify";

import { copyToClipboard } from "utils/common";

export const validateManufacturerDropdownInput = (input: string[]) => {
  if (input.includes("all")) return null;
  else return Number(input.at(0));
};

export const handleCopyToClipboard = (content: string, message: string) => copyToClipboard(content).then(() => toast.success(message));
